import { render, staticRenderFns } from "./ServerPopup.vue?vue&type=template&id=171e830d&scoped=true"
import script from "./ServerPopup.vue?vue&type=script&lang=js"
export * from "./ServerPopup.vue?vue&type=script&lang=js"
import style0 from "./ServerPopup.vue?vue&type=style&index=0&id=171e830d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171e830d",
  null
  
)

export default component.exports